import yieldLadder from './yieldLadder.en'
import whitepaper from './whitepaper.en'
import rulesSecurity from './rulesSecurity.en'

export default {
  lendingContent: {
    yieldLadder,
    whitepaper,
    rulesSecurity
  }
}
